import type { W1GrammarAnalysisResponse, W2SentenceAnalysisResponse } from './api';

type ExportItem = { question_id: string; source_test_id?: string };
export type TemplateExportRequest = {
  studentId: string;
  userName: string;
  bankVersion: string;
  level: number;
  category: string;
  testId?: string;
  items: ExportItem[];
  grammar?: W1GrammarAnalysisResponse | null;
  sentenceAnalysis?: W2SentenceAnalysisResponse | null;
  variant?: 'student' | 'teacher';
  format?: 'pdf' | 'docx';
};

export async function downloadTemplateExport(token: string, input: TemplateExportRequest) {
  if (input.format === 'docx') {
    const { downloadTemplateDocx } = await import('./templateDocx');
    return downloadTemplateDocx(token, input);
  }
  const root = `${BACKEND_URL.replace(/\/$/, '')}/template-pdf`;
  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
  const read = async (response: Response) => {
    const body = await response.json();
    if (!response.ok) throw new Error(body.message || '文档生成失败，请稍后重试');
    return body;
  };
  const id = crypto.randomUUID();
  const { items, format = 'pdf', ...rest } = input;
  await read(await fetch(`${root}/jobs`, {
    method: 'POST', headers,
    body: JSON.stringify({ ...rest, id, variant: input.variant || 'student',
      questions: items.map(q => ({ questionId: q.question_id, testId: q.source_test_id || input.testId })) })
  }));
  const until = Date.now() + 240_000;
  while (Date.now() < until) {
    const job = await read(await fetch(`${root}/jobs/${id}`, { headers }));
    if (job.state === 'failed') throw new Error(job.error || '文档转换失败，请重试');
    if (job.state === 'completed') {
      const file = await fetch(`${root}/jobs/${id}/${format}`, { headers });
      if (!file.ok) await read(file);
      const blob = await file.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const label = input.variant === 'teacher' ? '教师答案版' : '学生练习版';
      link.download = `${input.userName.replace(/[^\w\u3400-\u9fff-]+/g, '_')}-HSK-${input.bankVersion}-Level-${input.level}-${label}.${format}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 60000);
      return;
    }
    await new Promise(resolve => window.setTimeout(resolve, 2500));
  }
  throw new Error('文档仍在处理中，请稍后重试');
}
